import { Environment, ENVIRONMENTS } from '../../constants/environments';

const currentEnvironment = import.meta.env.VITE_APP_ENVIRONMENT as Environment;

const defaultConfig = {
  instrumentationKey: import.meta.env.VITE_APPINSIGHTS_KEY || '',
  environment: currentEnvironment,
  additionalContext: {
    appVersion: import.meta.env.VITE_APP_VERSION || '1.0.0',
  },
  correlationHeaderExcludedDomains: [
    String(import.meta.env.VITE_APP_PIANO_COLLECTION_DOMAIN ?? ''),
    // Datadog RUM/Logs intake. App Insights (enableCorsCorrelation:true) adds
    // traceparent/Request-Id headers to cross-origin fetch/XHR; the Datadog
    // browser SDK posts batches here as CORS-"simple" requests, so those extra
    // headers force a preflight the intake rejects -> "CORS error" on every
    // fetch-transport batch (sendBeacon batches are unaffected). App Insights
    // substring-matches these entries, so they also cover the
    // session-replay.browser-intake-datadoghq.* subdomain. Both .eu and .com
    // are listed so a future VITE_DD_SITE change to the US org still works.
    'browser-intake-datadoghq.eu',
    'browser-intake-datadoghq.com',
  ].filter(Boolean),
};

const environmentConfigs = {
  [ENVIRONMENTS.DEV]: {
    enableDebugMode: true,
  },
  [ENVIRONMENTS.TEST]: {
    enableDebugMode: true,
  },
  [ENVIRONMENTS.UAT]: {
    enableDebugMode: true,
  },
  [ENVIRONMENTS.PROD]: {
    enableDebugMode: false,
  },
};

export const telemetryConfig = {
  ...defaultConfig,
  ...(environmentConfigs[currentEnvironment] || {}),
};

export default telemetryConfig;
